export * from './consent.service';



// WEBPACK FOOTER //
// /home/jenkins/hydrogen/workspace/Release_Engineering/Artifactory-Release-Packagers/Builders/Conduit-Release/consent/src/app/consent/index.ts